import { useState } from "react";
import { useTranslation } from "react-i18next";
import TermsModal from "./TermsModal";
import styles from "./TermsAcceptance.module.css";

const TermsAcceptance = ({ accepted, onAcceptedChange }) => {
  const { t, i18n } = useTranslation();
  const [showTerms, setShowTerms] = useState(false);
  const language = i18n.language?.startsWith("tr") ? "tr" : "en";

  return (
    <>
      <label className={styles.acceptRow}>
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={accepted}
          onChange={(e) => onAcceptedChange(e.target.checked)}
        />
        <span className={styles.acceptText}>
          {t("Register.acceptTerms")}{" "}
          <button
            type="button"
            className={styles.termsLink}
            onClick={() => setShowTerms(true)}
          >
            {t("Register.readTerms")}
          </button>
        </span>
      </label>

      {showTerms && (
        <TermsModal
          language={language}
          onClose={() => setShowTerms(false)}
        />
      )}
    </>
  );
};

export default TermsAcceptance;
